import React from 'react';
import {useTranslation} from 'react-i18next';

import {useAuthStore} from '@/entities/session/auth-store';
import {MyLogsFeed} from '@/features/view-my-logs/ui/MyLogsFeed';
import {Page} from '@/shared/ui/page';
import {ContextPlaceholder} from '@/widgets/context-placeholder/ContextPlaceholder';

/**
 * «Я — сотрудник» → Мои проходы. События тоже ограничены собой на сервере.
 */
export function MyLogsScreen() {
  const {t} = useTranslation();
  const companyId = useAuthStore(s => s.activeContext?.companyId);

  if (!companyId) {
    return <ContextPlaceholder titleKey="nav.myLogs" />;
  }

  return (
    <Page gutter={false} title={t('nav.myLogs')} testID="my-logs-screen">
      <MyLogsFeed companyId={companyId} />
    </Page>
  );
}
